export function splitStringWithTags(text: string) {
  if (!text) {
    return [];
  }

  const pattern = /(<mark>|<\/mark>)/g;
  const parts = text?.split(pattern);
  const result = [];
  let currentPart = '';

  for (let i = 0; i < parts.length; i++) {
    const part = parts[i];

    if (part === '<mark>') {
      result.push(currentPart);
      currentPart = '';
    } else if (part === '</mark>') {
      result.push(`<mark>${currentPart}</mark>`);
      currentPart = '';
    } else {
      currentPart += part;
    }
  }

  result.push(currentPart);

  return result.filter((part) => part !== '');
}

export function isDarkMode(debug?: any) {
  if (
    (typeof window !== 'undefined' && window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) ||
    (typeof localStorage !== 'undefined' && localStorage.getItem('theme') === 'dark')
  ) {
    return true;
  }

  return false;
}

export function getScrollY() {
  return (typeof window !== 'undefined' && window.scrollY) || 0;
}

export function tryJSONParse(text: string) {
  try {
    JSON.parse(text);
    return true;
  } catch (e) {
    return false;
  }
}

export function normalizeArabic(text: string) {
  //remove special characters
  text = text.replace(/([^\u0621-\u063A\u0641-\u064A\u0660-\u0669a-zA-Z 0-9])/g, '');

  //normalize Arabic
  text = text.replace(/(آ|إ|أ)/g, 'ا');
  text = text.replace(/(ة)/g, 'ه');
  text = text.replace(/(ئ|ؤ)/g, 'ء');
  text = text.replace(/(ى)/g, 'ي');

  //convert arabic numerals to english counterparts.
  var starter = 0x660;
  for (var i = 0; i < 10; i++) {
    text.replace(String.fromCharCode(starter + i), String.fromCharCode(48 + i));
  }

  return text;
}

export function baseURL() {
  return process.env.NEXT_PUBLIC_BASE_URL || 'https://thaqalayn.net';
}

export function getMMDDYYDate(timestamp: string) {
  const date = new Date(parseInt(timestamp));
  const month = date.getMonth() + 1;
  const day = date.getDate();
  const year = date.getFullYear().toString().slice(-2);
  return `${month.toString().padStart(2, '0')}/${day.toString().padStart(2, '0')}/${year}`;
}

export function filterExact(results: any[], exact: boolean, term: string) {
  return results.filter((res: any) => (exact ? res?.document?.highlights[0].snippet.includes(term) : true));
}

export function isDev() {
  return process.env.NEXT_PUBLIC_IS_DEV === 'true';
}
